import { render, staticRenderFns } from "./AdapterCarousel.vue?vue&type=template&id=e8704e58&scoped=true&"
import script from "./AdapterCarousel.vue?vue&type=script&lang=js&"
export * from "./AdapterCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdapterCarousel.vue?vue&type=style&index=0&id=e8704e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8704e58",
  null
  
)

export default component.exports